module.exports = __webpack_public_path__ + "img/Waiting.png";